/* import __COLOCATED_TEMPLATE__ from './seller-posting-expired.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';

const CLASS_NAME = 'SH-seller-posting-expired';

export default class SellerPostingExpiredComponent extends Component {
  @service router;

  get className() {
    return CLASS_NAME;
  }

  @action
  onOtherPostingsClick() {
    this.router.transitionTo(EMBER_ROUTE_NAMES.POSTINGS__FIND_WORK);
  }
};
